import { User } from "@app/shared/models";
import { SampleBoard } from "@app/strain/sample-boards/models/sample-board.model";
import { SampleBoardItem } from "@app/strain/sample-boards/models/sample-board-item.model";
import { SampleBoardBuildEvent } from "@app/strain/sample-boards/models/build/sample-board-build-event.model";

export enum SampleBoardBuildStatus {
    New = 1,
    InProgress = 2,
    OnHold = 3,
    Done = 4,
}

export class SampleBoardBuildRequest {
    id: number;
    requestedQuantity: number;
    createdAt: string;
    createdBy: User;
    startedAt?: string;
    startedBy?: User;
    sample: SampleBoard;
    status: SampleBoardBuildStatus;
    buildTime?: number;
    buildItems?: SampleBoardItem[];
    events?: SampleBoardBuildEvent[];

    constructor(entry: any = {}) {
        this.id = entry?.id;
        this.requestedQuantity = entry.requestedQuantity;
        this.createdAt = entry?.createdAt;
        this.createdBy = entry?.createdBy ? new User(entry.createdBy) : null;
        this.startedAt = entry?.startedAt || entry?.startTime;
        this.startedBy = entry?.startedBy ? new User(entry.startedBy) : null;
        this.sample = entry?.sample ? new SampleBoard(entry.sample) : null;
        this.status = entry?.status;
        this.buildTime = entry?.buildTime ?? entry?.timerElapsedMs;
        this.buildItems = entry?.buildItems ? entry.buildItems.map(
            (ntry) => new SampleBoardItem(ntry)) : [];
        this.events = entry?.events ? entry.events.map((evt) => new SampleBoardBuildEvent(evt)) : [];
    }
}
